module.exports = __webpack_public_path__ + "img/Postcard-Planter-Series-01.6dfe5c54.jpg";